export default __webpack_public_path__ + "static/media/supply-tile.d3f18430.png";